import React from 'react';

interface CompletionWheelProps {
  completed: number;
  total: number;
  size?: number;
  strokeWidth?: number;
}

/**
 * B3 — Roue de complétion du parcours : donut SVG sans lib externe.
 * Affiche la part de points de connaissance validés du mode courant,
 * avec le pourcentage au centre. La légende (« X / Y points validés »)
 * est laissée à l'appelant pour s'adapter à chaque emplacement.
 */
const CompletionWheel: React.FC<CompletionWheelProps> = ({ completed, total, size = 96, strokeWidth = 10 }) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const ratio = total > 0 ? Math.min(Math.max(completed / total, 0), 1) : 0;
  const percent = Math.round(ratio * 100);

  return (
    <div
      className="relative inline-flex items-center justify-center"
      style={{ width: size, height: size }}
      role="img"
      aria-label={`${completed} points de connaissance validés sur ${total}`}
    >
      <svg width={size} height={size} className="-rotate-90">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          strokeWidth={strokeWidth}
          className="stroke-gray-200 dark:stroke-gray-700"
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={circumference * (1 - ratio)}
          className="stroke-blue-600 dark:stroke-blue-400 transition-all duration-700"
        />
      </svg>
      <span className="absolute font-bold text-gray-900 dark:text-white" style={{ fontSize: Math.max(12, size / 6) }}>
        {percent}%
      </span>
    </div>
  );
};

export default CompletionWheel;
